import styled from 'styled-components';

const ClaveDinamicaSMSContenedor = styled.div`
  position: relative;
  bottom: ${props => props.isMounted ? 'unset' : '260px'};

  .InputCoordinateCard .InputCoordinateCard__input-group {
    column-gap: 10px;
  }
  .Input__input > input {
    width: 50px !important;
  }
  .loading-container {
    display: ${props => props.loading ? 'flex' : 'none'};
    justify-content: center;
    align-items: center;
    height: 260px;
    background-color: #ffffffa6;
  }
  .loading-container > img {
    height: fit-content;
  }
  .card {
    display: ${props => props.loading ? 'none' : 'block'};
    box-shadow: none;
    padding: 0;
    border: 1px solid #e2e2e2;
  }
  h1 {
    font-size: 15px;
    font-weight: 400;
    border-bottom: 1px solid #e2e2e2;
    padding-left: 18px;
    padding-top: 5px;
    padding-bottom: 5px;
    background-color: #effaff;
  }
  .p-mensaje {
    font-size: 14px;
    text-align: center;
    line-height: 1.33rem;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 5px;
  }
  .span-mensaje-celular {
    color: #e81e2b;
    font-weight: 500;
  }
  .Input__label-wrapper {
    display: none;
  }
  .label-titulo {
    font-size: 14px;
    font-weight: 500;
    padding-left: 15px;
    padding-top: 5px;
    margin-bottom: 0px;
  }
  .card-content > *:nth-child(-n+3) {
    opacity: ${props => props.casoBordeIntentosFallidos ? '0.3' : 'unset'};
  }
  .caso-borde-intentos{
    display: ${props => props.casoBordeIntentosFallidos ? 'flex' : 'none'};
    background-color: #f9d4d5;
    color: #c0073c;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 15px;
    padding-left: 16px;
    padding-top: 14px;
    flex-direction: column;
  }
  .titulo{
    font-weight: 600;
    display: flex;
    font-size: 14px;
  }
  .titulo > span {
    padding-left: 8px;
  }
  .descripcion{
    padding-left: 28px;
    padding-bottom: 14px;
  }
  .p-descripcion{
    font-size: 12px;
    line-height: 18px;
  }
  .numero-atencion {
    font-weight: 600;
  }
`;

export default ClaveDinamicaSMSContenedor;
